import React from "react";
import "@fontsource/nunito/400.css";
import "@fontsource/nunito/600.css";
import "@fontsource/inter/500.css";
import Ellipse1 from "../../assets/subscribe-imgs/Ellipse1.png";
import Ellipse2 from "../../assets/subscribe-imgs/Ellipse2.png";
import Ellipse3 from "../../assets/subscribe-imgs/Ellipse3.png";
import Ellipse4 from "../../assets/subscribe-imgs/Ellipse4.png";
import Ellipse5 from "../../assets/subscribe-imgs/Ellipse5.png";

const SubscribeCard = () => {
  const circlePositions = [
    "left-[6%] top-[10%] lg:left-[80px] lg:top-[39px]",
    "left-[18%] top-[32%] lg:left-[217px] lg:top-[121px]",
    "left-[8%] bottom-[12%] lg:left-[113px] lg:bottom-[42px]",
    "right-[8%] top-[10%] lg:right-[114px] lg:top-[40px]",
    "right-[16%] top-[38%] lg:right-[216px] lg:top-[147px]",
    "right-[6%] bottom-[12%] lg:right-[83px] lg:bottom-[45px]",
  ];

  const circleImages = [
    Ellipse1,
    Ellipse2,
    Ellipse3,
    Ellipse3,
    Ellipse4,
    Ellipse5,
  ];

  return (
    <div className="bg-white px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-[1920px] pb-14 pt-6 sm:pb-20 sm:pt-8 2xl:pb-[118px]">
        <h1 className="text-center text-[26px] font-bold leading-tight text-black sm:text-[32px] sm:leading-[56px]">
          We’re Here for You
        </h1>
        <p className="mt-3 text-center text-sm leading-5 text-black sm:mt-4 sm:text-base sm:leading-[19px]">
          Drop your number and we’ll connect with you directly.
        </p>
        <div className="mt-8 flex justify-center font-['Nunito'] sm:mt-12 md:mt-16 2xl:mt-[73px]">
          <div className="relative w-full max-w-[1280px] overflow-hidden rounded-[16px] bg-[#923D8C] px-4 py-10 sm:rounded-[20px] sm:px-6 sm:py-12 md:px-8 md:py-16">
            {circlePositions.map((position, idx) => (
              <div
                key={idx}
                className={`absolute hidden h-10 w-10 overflow-hidden rounded-full opacity-70 sm:block sm:h-12 sm:w-12 md:h-14 md:w-14 lg:h-16 lg:w-16 lg:opacity-100 ${position}`}
              >
                <img
                  src={circleImages[idx]}
                  alt=""
                  className="h-full w-full object-cover"
                />
              </div>
            ))}

            <div className="relative z-10 mx-auto flex w-full max-w-[660px] flex-col items-center px-1 text-center text-white sm:px-0">
              <h2 className="font-['Work Sans'] text-2xl font-semibold leading-snug sm:text-3xl sm:leading-10 md:text-4xl md:leading-[47px]">
                Do you still have any questions?
              </h2>
              <p className="mt-3 max-w-[527px] font-['Nunito'] text-sm leading-6 opacity-80 sm:mt-4 sm:text-base sm:leading-6">
                Don&apos;t hesitate to leave us your phone number. We will
                contact you to discuss any questions you may have.
              </p>

              <div className="mt-6 flex w-full max-w-[509px] flex-col overflow-hidden rounded-[10px] bg-[#A955A3] sm:mt-8 sm:flex-row">
                <input
                  type="tel"
                  placeholder="Enter your phone number"
                  className="min-h-12 flex-1 bg-transparent px-4 font-['Nunito'] text-sm text-white placeholder:text-white focus:outline-none sm:min-h-[60px] sm:text-base"
                />
                <button
                  type="button"
                  className="min-h-12 shrink-0 bg-white px-6 font-['Inter'] text-sm font-medium text-[#FF6636] sm:min-h-[60px] sm:min-w-[142px] sm:px-8 sm:text-base"
                >
                  Subscribe
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscribeCard;
